import React from "react";
import Style from "./Rating.module.scss";
import moment from "moment";
import { PreloaderComponent } from "@components/preloader";

interface MyActivityViewProps {
  detailedRating: {
    createdAt: string;
    description: string;
    size: number;
  }[];
}

export const MyActivityView = ({ detailedRating }: MyActivityViewProps) => {
  function dateFormat(dateString: string) {
    const date = moment(dateString);

    return date.format("D MMMM YYYY");
  }

  if (!detailedRating) {
    return (
      <div className={Style.ratingPanel}>
        <PreloaderComponent />
      </div>
    );
  }

  return (
    <>
      <ul className={Style.ratingPanel}>
        {detailedRating.map((item: any, index: number) => {
          return (
            <li key={index} className={Style.item}>
              <div className={Style.itemDate}>{dateFormat(item.createdAt)}</div>
              <div className={Style.itemContent}>
                <div className={Style.itemDesc}>{item.description}</div>
              </div>
              <div className={Style.itemCount}>{item.size}</div>
            </li>
          );
        })}
      </ul>
    </>
  );
};
